import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-input-text-sequence',
  templateUrl: './input-text-sequence.component.html',
  styleUrls: ['./input-text-sequence.component.scss']
})
export class InputTextSequenceComponent implements OnInit {
  /**
   * Esquema de mat-form-field
   */
  @Input() text = {};
  /**
   * Sequence maximo
   */
  @Input() max = 1;
  /**
   * Lista de valores para la secuencia
  */
  @Input() list = [];
  /**
   * clase css bootstrap para mat-form-field
   */
  @Input() classInput;
  /**
   * Lista de Valores emit
   */
  @Output() data: EventEmitter<string[]> = new EventEmitter<string[]>();
  /**
   * Lista de valores del componente
   */
  public listInput: string[] = [];
  /**
   * Ngclass dinamico de mat-form-field
   */
  classInputParse
  /**
   *
   */
  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(): void {
    this.listInput = this.list && this.list.length ? this.list : [''];
    this.classInputParse = {[this.classInput]: true}
  }

  deleteControl(index: number) {
    this.listInput.splice(index, 1);
    this.data.emit(this.listInput);
  }

  addControl() {
    this.listInput.push('');
  }

  updateControl(event, index) {
    this.listInput[index] = event;
    this.data.emit(this.listInput);
  }

  trackById = (_index: number, item: any) => {
    return _index;
  }

}
